// extracted by mini-css-extract-plugin
module.exports = {"root":"FrontImage_root__2vyD2","title":"FrontImage_title__7n__7"};